<template>
  <div>
    <v-card flat class="pa-3">
      <v-card-actions class="mb-1 pb-0">
        <div
          class="d-flex overflow-hidden card-rounded"
          style="border: 1px solid #ccc"
        >
          <v-text-field
            class="mx-1"
            v-model="search"
            prepend-inner-icon="search"
            :label="$t('common.Search')"
            single-line
            hide-details
            solo
            flat
          />
        </div>
        <v-spacer />
        <div>
          <v-select
            v-model="logtype"
            :loading="loading"
            label="Logbook"
            item-value="id"
            item-text="name"
            :items="logtypes"
            single-line
            hide-details
            solo
            class="thin-border"
          />
        </div>
      </v-card-actions>

      <v-data-table
        :loading="loading"
        :headers="headers"
        class="elevation-0"
        :items="displayableLogs"
        :pagination.sync="pagination"
        :custom-sort="customSort"
      >
        <template v-slot:headers="props">
          <tr>
            <th>Interno</th>
            <th
              v-for="header in props.headers"
              :key="header.text"
              :class="[
                'column sortable',
                pagination.descending ? 'desc' : 'asc',
                header.value === pagination.sortBy ? 'active' : ''
              ]"
              @click="changeSort(header.value)"
            >
              <v-icon small>arrow_upward</v-icon>
              {{ header.text }}
            </th>
          </tr>
        </template>
        <template v-slot:items="props">
          <tr>
            <td>
              {{ props.item.userName }}
            </td>
            <td
              v-for="component in displayableComponents"
              :key="component.id"
              style="text-align: center"
              @click="() => displayLog(props.item.id)"
            >
              <span
                v-if="typeof props.item[component.id] === 'boolean'"
                class="ml-3"
              >
                <v-icon v-if="props.item[component.id]" small>check</v-icon>
              </span>
              <span v-else>{{ getCroppedText(props.item[component.id]) }}</span>
            </td>
          </tr>
        </template>
        <template v-if="fetchingLogs" v-slot:no-data>
          <tr style="visibility: hidden" />
        </template>
      </v-data-table>
    </v-card>
    <v-dialog
      v-model="showDisplayDialog"
      :persistent="true"
      :fullscreen="isMobile"
      lazy
    >
      <LogForm
        :updateMode="false"
        :log-to-edit="logToDisplay"
        :key="(logToDisplay || {}).id"
        :close="closeDisplayLogForm"
      />
    </v-dialog>
  </div>
</template>
<script>
import { Logbook, Component, Option } from '../../../models/Specialty'
import { mapActions, mapGetters } from 'vuex'
import Specialty from '@/models/Specialty'
import LogForm from '../../Logbook/components/LogForm.vue'
import moment from 'moment'
export default {
  props: {
    selectedUsers: {
      type: Array
    },
    coordinatedUsers: {
      type: Array
    }
  },
  components: {
    LogForm
  },
  data() {
    return {
      fetchingLogs: true,
      showDisplayDialog: false,
      logToDisplay: null,
      search: '',
      logtype: '',
      pagination: {
        sortBy: 'createdAt',
        rowsPerPage: 10,
        descending: true
      }
    }
  },
  computed: {
    ...mapGetters(['labeledCoordinatorLogs', 'coordinatorLogs']),
    loading() {
      return this.fetchingLogs || this.components.length === 0
    },
    logtypes() {
      return Logbook.query().get()
    },
    options() {
      return Option.query()
        .get()
        .sort((a, b) => {
          a.value.localeCompare(b.value)
        })
    },
    components() {
      return Component.query().withAllRecursive().get() || []
    },
    logbooks() {
      return Logbook.query().get()
    },
    specialty() {
      return Specialty.getSpecific(this.$store.getters.specialty)
    },

    headers() {
      const headers = this.components
        .filter(c => c.show)
        .filter(c => c.logbooks && c.logbooks.includes(this.logtype))
        .map(({ label: text, id: value }) => ({
          text: this.$i18n.locale === 'pt' ? text : value,
          value,
          id: value
        }))

      headers.unshift({
        text: 'Data Criação',
        value: 'createdAt',
        id: 'createdAt'
      })

      return headers
    },
    Logs() {
      const coordinatorLogs = this.coordinatorLogs || []
      return coordinatorLogs ? coordinatorLogs : []
    },
    displayableComponents() {
      const components = this.components.filter(
        c => c.show && c.logbooks.includes(this.logtype)
      )

      components.unshift({
        id: 'createdAt',
        label: 'Data Criação',
        show: true
      })

      return components
    },
    labeledLogs() {
      const LabeledCoordinatorLogs = this.labeledCoordinatorLogs || []
      return LabeledCoordinatorLogs ? LabeledCoordinatorLogs : []
    },

    displayableLogs() {
      let logs = this.labeledLogs.filter(log => log.logbook === this.logtype)
      if (this.search) {
        logs = this.searchIt(logs, this.search)
      }

      logs.map(log => {
        const displayableLog = { id: log.id }
        displayableLog.logbook = log.logbook
        displayableLog.userId = log.userId

        this.displayableComponents.forEach(c => {
          displayableLog[c.id] = log[c.id]
        })

        const userData = this.coordinatedUsers.find(
          u => u.id === displayableLog.userId
        )

        if (userData) {
          displayableLog.userName = `${userData.firstName} ${userData.lastName}`
          log.userName = displayableLog.userName
        }

        return displayableLog
      })

      return logs
    },

    isMobile() {
      return this.$vuetify.breakpoint.smAndDown
    }
  },

  methods: {
    ...mapActions([
      'getCoordinatorLogs',
      'setCoordinatorLogs',
      'getLabeledCoordinatorLogs',
      'showErrorSnackbar'
    ]),
    searchIt(logs, searchKey) {
      // consider adding a MEGA string with all terms in the log object, do this in the store
      searchKey = searchKey
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
      const result = logs.filter(log => {
        return Object.keys(log).some(key => {
          if (typeof log[key] === 'object' && log[key] && log[key].text) {
            // excluding date and other objects from search
            const logValue = log[key].text
              .toString()
              .toLowerCase()
              .normalize('NFD')
              .replace(/[\u0300-\u036f]/g, '')
            return logValue.includes(searchKey)
          }
        })
      })
      return result
    },
    ageHandler(field) {
      if (field === '> 90') {
        return '91'
      } else if (isNaN(field)) {
        const regexpWithoutletters = /\b[0-9]+\b/gi
        const values = field
          .split(/([0-9]+)/)
          .join(' ')
          .match(regexpWithoutletters)

        return (
          values[0] +
          '.' +
          ('0' + values[1]).slice(-2) +
          ('0' + values[2]).slice(-2)
        )
      }
      return field
    },
    customSort(logs, index, isDesc) {
      if (logs) {
        if (index) {
          const direction = isDesc ? -1 : 1
          logs.sort((a, b) => {
            if (!a[index] || !a[index].text) {
              return direction * -1
            } else if (!b[index] || !b[index].text) {
              return direction * 1
            } else if (index === 'entry-date' || index === 'createdAt') {
              return (
                direction *
                (moment(a[index].text, 'DD/MM/YYYY').toDate() <
                moment(b[index].text, 'DD/MM/YYYY').toDate()
                  ? -1
                  : 1)
              )
            } else if (index === 'age') {
              return (
                direction *
                (this.ageHandler(a[index].text) -
                  this.ageHandler(b[index].text))
              )
            } else {
              return direction * (a[index].text < b[index].text ? -1 : 1)
            }
          })
        }
      }
      return logs
    },

    changeSort(column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending
      } else {
        this.pagination.sortBy = column
        this.pagination.descending = false
      }
    },

    getCroppedText(item) {
      if (!item || !item.text) return ''
      if (!isNaN(item.text)) return item.text
      return item.text.length < 50
        ? item.text
        : `${item.text.toString().substring(0, 49)}...`
    },

    displayLog(logId) {
      this.logToDisplay = this.Logs.find(l => l.id === logId)
      this.showDisplayDialog = true
    },
    closeDisplayLogForm() {
      this.showDisplayDialog = false
      this.logToDisplay = null
    }
  },

  created() {
    if (this.logtypes.length && !this.logtype)
      this.logtype = this.logtypes[0].id

    if (this.selectedUsers && this.selectedUsers.length) {
      this.getCoordinatorLogs(this.selectedUsers)
        .catch(() => {
          this.showErrorSnackbar('Something went wrong')
        })
        .finally(() =>
          this.getLabeledCoordinatorLogs().then(() => {
            this.fetchingLogs = false
          })
        )
    } else {
      this.fetchingLogs = false
    }
  },
  watch: {
    selectedUsers(newUser) {
      this.fetchingLogs = true
      this.setCoordinatorLogs([])
      this.getCoordinatorLogs(newUser)
        .catch(err =>
          this.showErrorSnackbar(err.message || 'Something went wrong')
        )
        .finally(() =>
          this.getLabeledCoordinatorLogs().then(() => {
            this.fetchingLogs = false
          })
        )
    },
    deep: true
  }
}
</script>
<style>
td span {
  white-space: pre-line;
}
</style>
